import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageToggle(){
  const { i18n } = useTranslation();
  return (
    <div className="flex gap-2">
      <button onClick={()=>i18n.changeLanguage('en')} className="px-2 py-1 border">EN</button>
      <button onClick={()=>i18n.changeLanguage('mr')} className="px-2 py-1 border">MR</button>
    </div>
  );
}